export default __webpack_public_path__ + "static/media/scanner.743de3e3.png";